import { Grid, Typography } from '@mui/material';
import styles from '../ServicesMenu/services.module.scss'

const HumanServicesPolicy = () => {
    const policy = (): React.ReactElement => {
        return (
            <>
                <Grid>
                    <Typography className={styles.content}>
                        <div className={styles.properspace}>
                            The Human Services Committee is an integral part of HCCC and is chartered with the
                            responsibility of serving the communities locally and globally on a need basis. HCCC board
                            is the governing body for all Human Services activities.
                        </div>
                        <div className={styles.properspace}>
                            Hindu Community & Cultural Center (HCCC) will strive to meet the Human Services needs
                            of the worldwide community irrespective of religion, race, and cultural identity depending upon
                            the available funds, on a priority and need basis.
                        </div>
                        <div className={styles.properspace}>
                            HCCC allocates limited amount of funds each year for supporting eligible
                            organizations engaged strictly in Human Service functions. Recipient organizations
                            will be required to disclose the affiliations with other organizations to enable HCCC
                            to determine their eligibility to receive HCCC charity funds.
                        </div>
                        <div className={styles.properspace}>
                            Human Service projects are mainly aimed at basic human needs as food, shelter,
                            medical and educational purposes. All of its funds will be spent in these areas only.
                            Any deviation from this requires the approval from HCCC.
                        </div>
                        <div className={styles.properspace}>
                            HCCC approves Human Service projects anywhere on the globe without geographical
                            limitations. Human Services Committee strives hard to create reliable ways and
                            means so that the projects are well executed and
                            funds are 100% utilized on the targeted project.
                        </div>
                        <div className={styles.properspace}>
                            Human Services Committee welcomes the association of individuals and groups who
                            would like to identify, donate and execute projects for human cause within its
                            spectrum of coverage.
                        </div>
                    </Typography>
                </Grid>
            </>
        )
    }
    return (
        <div className={styles.policytotalLayout}>
            <Grid className={styles.cardContainer}>
                <Typography className={styles.header}>
                    Policy
                </Typography>
                {policy()}
            </Grid>
        </div>
    )
}
export default HumanServicesPolicy;